import styled, { css } from 'styled-components'
import { Breakpoints } from 'Pages/landings/common/styles'
import InputMask from 'react-input-mask'
import DatePicker from 'react-datepicker'

export const media = (props: string, width: string) => `
	@media (min-width: ${width}) {
		${props}
	}
`
export const mediaOnly = (props: string, minWidth: string, maxWidth: string) => `
	@media (min-width: ${minWidth}) and (max-width: ${maxWidth}){
		${props}
	}
`
export const textStyled = (family, size, weight, height, color, marbot) => `
	font-family: ${family};
	font-style: normal;
	font-weight: ${weight};
	font-size: ${size};
	line-height: ${height};
	color: #${color};
	margin-bottom: ${marbot};
`
export const Text = styled.span<{ color: string }>`
	${({ color }) =>
		css`
			color: #${color};
		`}
`

export const Block = styled.div`
	padding: 0px 24px;
	${media('padding: 0px 32px;', Breakpoints.md)}
	${media('padding: 0px 40px;', Breakpoints.xl)};
	${media('padding: 0px 256px;', Breakpoints.xxl)}
	position: relative;
	width: 100%;
	box-sizing: border-box;
`

const buttonStyle = css`
	height: 44px;
	min-height: 44px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 0px;
	background: #21ba72;
	border-radius: 43px;
	${textStyled('SBSansText', '14px', 700, '20px', 'FFFFFF', '0px')};
	${media('border-radius: 32px; font-weight: 600;', Breakpoints.md)};
	${media('border-radius: 64px;', Breakpoints.xxl)};
	&:disabled {
		background: #90dcb8;
		cursor: not-allowed;
	}
	&:active,
	&:hover,
	&:focus {
		background: #198c56;
	}
`
export const ButtonGeneral = styled.button`
	${buttonStyle}
`

export const HrefButton = styled.a`
	text-decoration: none;
	${buttonStyle}
`

export const gridHalf = css`
	display: grid;
	grid: repeat(2, 34px) / 1fr;
	row-gap: 34px;
	justify-content: space-between;
	margin-bottom: 34px;
	${media('column-gap: 16px; grid: 34px / repeat(2, 1fr);', Breakpoints.md)};
`
export const GridHalf = styled.div`
	${gridHalf}
`

export const flex = css`
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
`

export const input = css<{
	isError?: boolean
	disabled?: boolean
}>`
	${textStyled('SBSansText', '12px', 400, '16px', '373A44', '5px')};
	width: 100%;
	height: 32px;
	border: none;
	border-bottom: 1px solid #d9d9d9;
	padding: 0px;
	margin: 0px;
	&:hover,
	&:focus {
		border-bottom: 1px solid #d9d9d9;
		box-shadow: none;
		outline: none;
	}
	&::placeholder {
		${textStyled('SBSansText', '10px', 400, '12px', '4E545D', '0px')};
	}
	&:-webkit-autofill,
	&:-webkit-autofill:hover,
	&:-webkit-autofill:focus {
		border-bottom: 1px solid ${({ isError }) => (isError ? '#ff0066' : '#d9d9d9')};
		-webkit-text-fill-color: #373a44;
		-webkit-box-shadow: 0 0 0px 1000px white inset;
		transition: background-color 5000s ease-in-out 0s;
		background-color: rgb(27, 187, 79);
		caret-color: #373a44;
		font-size: 12px !important;
		font-family: inherit !important;
	}
	${({ isError }) =>
		isError &&
		css`
			border-color: #ff0066;
		`}

	${({ disabled }) =>
		disabled &&
		css`
			background: rgb(245, 245, 245);
		`}
	${media('font-size: 14px; line-height: 20px;', Breakpoints.xl)};
`
export const InputDefault = styled.input<{
	isError?: boolean
	disabled?: boolean
}>`
	${input}
`
export const InputPhone = styled(InputMask)<{
	isError?: boolean
	disabled?: boolean
}>`
	${input}
`
export const InputDate = styled(DatePicker)<{
	isError?: boolean
	disabled?: boolean
}>`
	${input}
`
